export const NAV = [
  { label: "Mats", to: "/mats" },
  { label: "Wall Pads", to: "/wall-pads" },
  { label: "Custom Solutions", to: "/custom-solutions" },
  { label: "Installations", to: "/installations" },
  { label: "About MAKO", to: "/about" },
  { label: "Resources", to: "/resources" },
  { label: "Contact", to: "/contact" },
];

export const LOGO = {
  primary:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_f33a589d-6ae1-4fa8-937d-37a21884ea4e/artifacts/hpx46hdn_MAKO_Mats_Primary_Tagline_DigitalGradient_Transparent.webp",
  icon: "https://customer-assets-wrfwihn1.emergentagent.net/job_f33a589d-6ae1-4fa8-937d-37a21884ea4e/artifacts/ky6dm2jl_MAKO_Mats_Icon_DigitalGradient_Transparent.webp",
};

export const BENEFITS = [
  {
    icon: "Layers",
    title: "Performance",
    copy: "Surfaces selected for real combat-sport movement, grip and daily use.",
  },
  {
    icon: "ShieldCheck",
    title: "Protection",
    copy: "Purpose-built flooring and wall padding for safer training environments.",
  },
  {
    icon: "Activity",
    title: "Durability",
    copy: "Designed for busy academies, repeated impact and high training volume.",
  },
  {
    icon: "Frame",
    title: "Professional finish",
    copy: "Create a cleaner, more complete and more credible training facility.",
  },
  {
    icon: "Headset",
    title: "Straightforward support",
    copy: "Clear product guidance, custom planning and help choosing the right solution.",
  },
];

export const SPORTS = [
  {
    name: "MMA",
    copy: "Balance striking footwork with takedowns and ground work on a single surface.",
    considerations: [
      "Stability underfoot for striking and footwork",
      "Cushioning for repeated takedowns",
      "Wall and column protection near the working area",
    ],
    recommended: ["MAKO Rollout", "MAKO Tatami"],
    walls: "Full-height panels on contact walls, wrapped corners and columns.",
    image_key: "mma_rollout",
  },
  {
    name: "BJJ",
    copy: "Prioritise grip, comfort, durability and a consistent surface across the full grappling area.",
    considerations: [
      "Predictable grip for bare feet and gi",
      "Consistent feel from centre to perimeter",
      "Comfort across long rolling rounds",
    ],
    recommended: ["MAKO Tatami", "MAKO Rollout"],
    walls: "Partial-height padding where rolling reaches the walls.",
    image_key: "bjj",
  },
  {
    name: "Wrestling",
    copy: "A near-seamless surface with dependable impact absorption for high-volume drilling.",
    considerations: [
      "Minimal joins across the working area",
      "Consistent impact absorption",
      "Clear zone or circle markings",
    ],
    recommended: ["MAKO Rollout"],
    walls: "Perimeter padding around the full mat line.",
    image_key: "wrestling",
  },
  {
    name: "Judo",
    copy: "Throwing arts need a surface planned around landings and a defined contest area.",
    considerations: [
      "Impact absorption for throws",
      "Textured surface for gi grip",
      "Defined contest and safety zones",
    ],
    recommended: ["MAKO Tatami", "MAKO Rollout"],
    walls: "Padding on all walls within the throwing area.",
    image_key: "judo_modern",
  },
  {
    name: "Muay Thai",
    copy: "Striking-led rooms benefit from a stable surface and protected walls behind bag lines.",
    considerations: [
      "Stable footing for pivots and kicks",
      "Simple maintenance around bag areas",
      "Protection behind and between bags",
    ],
    recommended: ["MAKO Puzzle", "MAKO Rollout"],
    walls: "Panels behind bag lines and along the working perimeter.",
    image_key: "mma_room",
  },
  {
    name: "Kickboxing",
    copy: "Flexible layouts that can be reconfigured between classes and pad-work sessions.",
    considerations: [
      "Reconfigurable layout",
      "Even surface for footwork drills",
      "Hard-wearing finish for daily classes",
    ],
    recommended: ["MAKO Puzzle", "MAKO Rollout"],
    walls: "Partial-height panels on the main working walls.",
    image_key: "multi_zones",
  },
  {
    name: "Traditional Martial Arts",
    copy: "A calm, considered dojo surface with a consistent tatami feel underfoot.",
    considerations: [
      "Traditional tatami texture",
      "Clean, uniform appearance",
      "Defined training and lining-up areas",
    ],
    recommended: ["MAKO Tatami", "MAKO Puzzle"],
    walls: "Restrained partial-height padding where required.",
    image_key: "judo_academy",
  },
  {
    name: "Multi-Discipline Gyms",
    copy: "Zoned surfaces so striking and grappling classes can run side by side.",
    considerations: [
      "Separate zones with different finishes",
      "Clear visual division between areas",
      "Room to extend the layout later",
    ],
    recommended: ["MAKO Puzzle", "MAKO Tatami", "MAKO Rollout"],
    walls: "Zone-specific padding with consistent colour treatment.",
    image_key: "multi_three",
  },
];

export const COMPARISON_ROWS = [
  { key: "installation_style", label: "Installation style" },
  { key: "portability", label: "Portability" },
  { key: "visual_finish", label: "Visual finish" },
  { key: "best_suited_for", label: "Best suited for" },
  { key: "customisation", label: "Customisation" },
  { key: "facility_type", label: "Typical facility type" },
];

export const PROCESS = [
  {
    step: "01",
    title: "Discuss",
    copy: "Tell MAKO about the room, sport, usage and priorities.",
  },
  {
    step: "02",
    title: "Select",
    copy: "Choose the right surface, thickness, finish and wall-padding configuration.",
  },
  {
    step: "03",
    title: "Design",
    copy: "Confirm colours, layout, dimensions and custom branding.",
  },
  {
    step: "04",
    title: "Deliver",
    copy: "Prepare the order and support the installation process.",
  },
];

export const PLANNER = [
  {
    id: "surface",
    label: "Main training surface",
    copy: "The working area, planned wall to wall or as a defined zone within the room.",
    top: "62%",
    left: "42%",
  },
  {
    id: "walls",
    label: "Wall pads",
    copy: "Padded panels along the walls that training reaches most often.",
    top: "34%",
    left: "18%",
  },
  {
    id: "corners",
    label: "Corners and columns",
    copy: "Wrapped sections that remove exposed hard edges inside the training area.",
    top: "44%",
    left: "74%",
  },
  {
    id: "logos",
    label: "Custom logos",
    copy: "Printed marks on the surface or on wall panels, set out on a layout drawing.",
    top: "72%",
    left: "66%",
  },
  {
    id: "zones",
    label: "Colour zones",
    copy: "Contrast borders and areas that separate disciplines or class groups.",
    top: "52%",
    left: "26%",
  },
  {
    id: "competition",
    label: "Competition areas",
    copy: "Marked contest and safety zones for gradings, interclubs and events.",
    top: "26%",
    left: "56%",
  },
];

export const FACILITY_TYPES = [
  "New gym",
  "Existing gym upgrade",
  "Event area",
  "School or university",
  "Other",
];

export const SPORT_OPTIONS = SPORTS.map((s) => s.name);

export const PRODUCT_OPTIONS = [
  "Puzzle mats",
  "Tatami tiles",
  "Rollout mats",
  "Wall pads",
  "Unsure",
];

export const TIMELINES = [
  "Immediately",
  "Within 1 month",
  "1 – 3 months",
  "3 – 6 months",
  "Planning / researching",
];

export const RESOURCE_CATEGORIES = [
  "Choosing Combat Mats",
  "Gym Design",
  "Mat Care and Cleaning",
  "Installation",
  "Safety",
  "Sport-Specific Guides",
];

export const LEGAL_PAGES = {
  "privacy-policy": {
    title: "Privacy Policy",
    body: "MAKO Mats collects enquiry details only to respond to your project. This page sets out what information is collected, how it is stored, how long it is retained and how to request deletion. Full wording is published here as it is finalised.",
  },
  "terms-and-conditions": {
    title: "Terms and Conditions",
    body: "Commercial terms covering quotation validity, order confirmation, payment terms and liability are issued with every quotation. Full wording is published here as it is finalised.",
  },
  "shipping-and-delivery": {
    title: "Shipping and Delivery",
    body: "Delivery coverage, lead times, freight responsibilities and site-access requirements are confirmed with each order. Full wording is published here as it is finalised.",
  },
  "returns-and-cancellations": {
    title: "Returns and Cancellations",
    body: "Cancellation windows, return eligibility for standard products and the position on custom-manufactured items are confirmed with each order. Full wording is published here as it is finalised.",
  },
  warranty: {
    title: "Warranty",
    body: "Warranty periods, cover and exclusions are confirmed in writing with each order. Full warranty wording will be published here once documented.",
  },
  "website-terms": {
    title: "Website Terms",
    body: "Acceptable use, intellectual property and third-party content terms for this website are published here as they are finalised.",
  },
};
